import { defineStore } from 'pinia'
import { ref } from 'vue'
import { callLogTagService } from '@/services/callLogTagService'
import type { CallLogTag } from '@/types/CallLogTag'

export const useCallLogTagStore = defineStore('callLogTag', () => {
  const tags = ref<CallLogTag[]>([])

  async function load() {
    tags.value = await callLogTagService.list()
  }

  return { tags, load }
})
